import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.find.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import { FAQ, PRIVACY_POLICY, LEGAL_NOTICE, CGU, CUSTOMER_REVIEWS, TERMS_CONDITIONS_PRO } from '~/const/faq';
import USE_MARKETPLACE from '~/const/marketplace';
import marketClosed from '~/helpers/marketClosed';
var MdmLink = function MdmLink() {
  return import('~/components/atoms/MdmLink.vue');
};
export default {
  name: 'Mentions',
  components: {
    MdmLink: MdmLink
  },
  props: {
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showModal: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    getDate: function getDate() {
      var d = new Date();
      return d.getFullYear();
    },
    setLocale: function setLocale() {
      return "".concat(this.locale.market, "/").concat(this.locale.language);
    },
    helpAndFaqsLinks: function helpAndFaqsLinks() {
      var _this = this;
      return FAQ.find(function (faq) {
        return faq.language === _this.locale.iso;
      }).url;
    },
    termsAndConditionsPro: function termsAndConditionsPro() {
      var _TERMS_CONDITIONS_PRO,
        _this2 = this;
      return ((_TERMS_CONDITIONS_PRO = TERMS_CONDITIONS_PRO.find(function (term) {
        return term.language === _this2.locale.iso;
      })) === null || _TERMS_CONDITIONS_PRO === void 0 ? void 0 : _TERMS_CONDITIONS_PRO.label) || null;
    },
    legalNoticeLinks: function legalNoticeLinks() {
      var _this3 = this;
      return LEGAL_NOTICE.find(function (legalNotice) {
        return legalNotice.language === _this3.locale.iso;
      }).url;
    },
    privacyPolicyLinks: function privacyPolicyLinks() {
      var _this4 = this;
      return PRIVACY_POLICY.find(function (privacyPolicy) {
        return privacyPolicy.language === _this4.locale.iso;
      }).url;
    },
    customerReviewsLinks: function customerReviewsLinks() {
      var _this5 = this;
      return CUSTOMER_REVIEWS.find(function (customerReviewLink) {
        return customerReviewLink.language === _this5.locale.iso;
      }).url;
    },
    cguLinks: function cguLinks() {
      var _CGU$find,
        _this6 = this;
      return (_CGU$find = CGU.find(function (cgu) {
        return cgu.language === _this6.locale.iso;
      })) === null || _CGU$find === void 0 ? void 0 : _CGU$find.links;
    },
    isMarketplaceOpen: function isMarketplaceOpen() {
      return USE_MARKETPLACE(this);
    },
    isMarketOpen: function isMarketOpen() {
      if (!this.locale) return true;
      var market = this.locale.market;
      return !marketClosed({
        market: market
      });
    }
  }),
  methods: {
    editCookies: function editCookies() {
      if (window.tC && window.tC.privacyCenter) {
        window.tC.privacyCenter.showPrivacyCenter();
      }
      return false;
    }
  }
};